import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { INDRAApiService } from './api.indra.service';
import { INDRAPaymentMethod, INDRARedeemVoucherDetail } from '@ibe.models/payment_method.model';
import { INDRAPaymentCreditCard, INDRAStatusTransaction, INDRAAuthorised, INDRASavedCardDeleteRequest, INDRASavedCardDeleteResponse } from '@ibe.models/payment_creditcard.model';
import { INDRABookingPnrExtend } from '@ibe.models/booking-extend.model';
import { INDRAPaymentIdentifyShopper } from '@ibe.models/payment_identifyshopper.model';
import { ModalService } from '@ibe/services/ui';

import { MOCK_STATUS, 
		MOCK_URL_PAYMENT_METHOD, 
		MOCK_URL_ENCRYPTED_AUTHORIZE,
		MOCK_URL_ENCRYPTED_AUTHORIZE_ISSUE_ERROR,
		MOCK_URL_ENCRYPTED_AUTHORIZE_ISSUE_KO,
		MOCK_URL_ENCRYPTED_REDIRECTSHOPPER,
		MOCK_URL_ENCRYPTED_IDENTIFYSHOPPER,
		MOCK_URL_ENCRYPTED_REJECTED_CYBERSOURCE,
		MOCK_URL_ENCRYPTED_REJECTED_FCE,
		MOCK_URL_ENCRYPTED_REJECTED_FCE_A,
		MOCK_URL_ENCRYPTED_REVIEW,
		MOCK_URL_ENCRYPTED_REVIEW_FCE,
		MOCK_URL_ENCRYPTED_REFUSED,
		MOCK_URL_ENCRYPTED_REDIRECTSHOPPER_OTHER_FOPS,
		MOCK_URL_PAYMENT_TRANSACTION_STATUS,
		MOCK_URL_PAYMENT_ALIPAY,
		MOCK_URL_PAYMENT_PRP,
		MOCK_URL_PAYMENT_DELETE_SAVED_CARD,
		MOCK_URL_PAYMENT_CHECK_FOP,
		MOCK_URL_PAYMENT_MULTICAIXA,
		MOCK_URL_PAYMENT_BANKTRANSFER_PICKUP,
		MOCK_URL_PAYMENT_CC_FEE,
		MOCK_URL_PAYMENT_CC_FEE_ZERO,
		URL_PAYMENTHUB,
		URL_PAYCARD,
		URL_PAYMENT_IDENTIFYSHOPPER,
		URL_PAYMENT_CHALLANGESHOPPER,
		URL_GET_STATUS_TRANSACTION,
		URL_AUTHORISED,
		URL_PAYCARD_BOOKING,
		URL_PAYMENT_REDIRECT,
		URL_PAYMENT_PRP_CREATE_ORDER,
		URL_PAYMENT_REMOVE_SAVED_CARD,
		URL_PNR_EXTEND,
		URL_PAYMENT_DECLINED_VALIDATION,
		URL_PAYMENT_CHECK_FOP,
		URL_IP_ADDRESS_EXTERNAL_SERVICE,
		URL_PAYMENT_MULTICAIXA,
		URL_PAYMENT_WITHOUT_GATEWAY,
		URL_PAYMENT_APPLY_CC_FEE,
		MOCK_URL_REDEEM_VOUCHER,
		URL_REDEEM_VOUCHER,
		MOCK_PAYBYRD_CHECKOUT,
		URL_CHECKOUT_PAYBYRD,
        URL_PNR_REPORT_TO_KIBANA
		} from '@ibe.config';

@Injectable({
  providedIn: 'root'
})
export class INDRAPaymentService {

	private _triggerHppRedFlag = new BehaviorSubject<boolean>(false);
	triggerHppRedFlag$ = this._triggerHppRedFlag.asObservable();

	constructor(
		private http: HttpClient,
		private modalService: ModalService,
		private api: INDRAApiService
	) { }

	public INDRAGetPaymentMethods(market: string): Observable<INDRAPaymentMethod> {
		if (MOCK_STATUS.PAYMENT_METHOD) {
			return this.http.get<INDRAPaymentMethod>(MOCK_URL_PAYMENT_METHOD);
		} else {
			return this.api.INDRA_post<INDRAPaymentMethod>(URL_PAYMENTHUB, { market: market });
		}
	}
	
	public INDRA_retrievePaymentMethods(market: string): Observable<INDRAPaymentMethod> {
		if (MOCK_STATUS.PAYMENT_METHOD) {
			return this.http.get<INDRAPaymentMethod>(MOCK_URL_PAYMENT_METHOD);
		} else {
			return this.api.INDRA_get<INDRAPaymentMethod>(URL_PAYMENTHUB + `?market=${market}`);
		}
	}
	
	public INDRA_paymentCreditCard(pay): Observable<INDRAPaymentCreditCard> {
		if (MOCK_STATUS.ENCRYPTED) {
			return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_AUTHORIZE); // uncomment if mock authorized issue ok
			// return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_AUTHORIZE_ISSUE_ERROR); // uncomment if mock authorized issue error
			// return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_AUTHORIZE_ISSUE_KO); // uncomment if mock authorized issue ko
			// return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_REDIRECTSHOPPER); // uncomment if mock redirectShopper
			// return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_IDENTIFYSHOPPER); // uncomment if mock identifyShopper
			// return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_REJECTED_CYBERSOURCE); // uncomment if mock rejected by cybersource
			// return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_REJECTED_FCE); // uncomment if mock rejected by fce
			// return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_REJECTED_FCE_A); // uncomment if mock rejected by fce (REJECT A)
			// return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_REVIEW); // uncomment if mock cybersource review
			// return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_REVIEW_FCE); // uncomment if mock fce review
			// return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_REFUSED); // uncomment if mock refused
			// return this.http.get<INDRAPaymentCreditCard>(MOCK_URL_ENCRYPTED_REDIRECTSHOPPER_OTHER_FOPS); // uncomment if mock redirect for other FOPs
		} else {
			return this.api.INDRA_post<INDRAPaymentCreditCard>(URL_PAYCARD_BOOKING, pay);
		}
	}
	
	public INDRA_paymentidentifyshopper(dataIdentifyShopper): Observable<INDRAPaymentIdentifyShopper> {
		return this.api.INDRA_post<INDRAPaymentIdentifyShopper>(URL_PAYMENT_IDENTIFYSHOPPER, dataIdentifyShopper);
	}

	public INDRA_challangeshopper(dataChallangeShopper): Observable<any> {
		return this.api.INDRA_post<any>(URL_PAYMENT_CHALLANGESHOPPER, dataChallangeShopper);
	}

	public INDRA_getStatusTransaction(dataIdOperation): Observable<INDRAStatusTransaction> {
		if (MOCK_STATUS.PAYMENT_TRANSACTION_STATUS) {
			return this.http.get<INDRAStatusTransaction>(MOCK_URL_PAYMENT_TRANSACTION_STATUS); 
		} else {
			return this.api.INDRA_post<INDRAStatusTransaction>(URL_GET_STATUS_TRANSACTION, dataIdOperation);
		}
	}

	public INDRA_authorised(dataAuthorised): Observable<INDRAAuthorised> {
		return this.api.INDRA_post<INDRAAuthorised>(URL_AUTHORISED, dataAuthorised);
	}
	
	public INDRA_paymentRedirectShopper(pay): Observable<any> {
		if (MOCK_STATUS.PAYMENT_REDIRECT) {
			return this.http.get<any>(MOCK_URL_PAYMENT_ALIPAY);
			// return this.http.get<any>(MOCK_URL_ENCRYPTED_REDIRECTSHOPPER_OTHER_FOPS);
		} else {
			return this.api.INDRA_post<any>(URL_PAYMENT_REDIRECT, pay);
		}
	}
	
	public INDRA_paymentPRP(pay): Observable<any> {
		if (MOCK_STATUS.PAYMENT_PRP) {
			return this.http.get<any>(MOCK_URL_PAYMENT_PRP);
		} else {
			return this.api.INDRA_post<any>(URL_PAYMENT_PRP_CREATE_ORDER, pay);
		}
	}
	
	public INDRA_removeSavedCard(req: INDRASavedCardDeleteRequest): Observable<INDRASavedCardDeleteResponse> {
		if (MOCK_STATUS.PAYMENT_REMOVE_SAVED_CARD) {
			return this.http.get<INDRASavedCardDeleteResponse>(MOCK_URL_PAYMENT_DELETE_SAVED_CARD);
		} else {
			return this.api.INDRA_post<INDRASavedCardDeleteResponse>(URL_PAYMENT_REMOVE_SAVED_CARD, req);
		}
	}

	public INDRA_bookingPnrExtend(): Observable<INDRABookingPnrExtend> {
		return this.api.INDRA_post<INDRABookingPnrExtend>(URL_PNR_EXTEND, null);
	}

	public INDRA_declinedValidation(request: any): Observable<any> {
		return this.api.INDRA_post<any>(URL_PAYMENT_DECLINED_VALIDATION, request);
	}

	public INDRA_bookingPnrReportToKibana(request: any): Observable<any> {
		return this.api.INDRA_post<any>(URL_PNR_REPORT_TO_KIBANA, request);
	}
	
	
	public INDRA_checkPaymentMethods(): Observable<any> {
		if (MOCK_STATUS.PAYMENT_CHECK_FOP) {
			return this.http.get<any>(MOCK_URL_PAYMENT_CHECK_FOP);
		} else {
			return this.api.INDRA_post<any>(URL_PAYMENT_CHECK_FOP, null);
		}
	}
	
	public INDRA_getIpAddress(): Observable<any> {
		return this.http.get<any>(URL_IP_ADDRESS_EXTERNAL_SERVICE);
	}
	
	public INDRA_paymentMulticaixa(pay): Observable<any> {
		if (MOCK_STATUS.PAYMENT_MULTICAIXA) {
			return this.http.get<any>(MOCK_URL_PAYMENT_MULTICAIXA);
		} else {
			return this.api.INDRA_post<any>(URL_PAYMENT_MULTICAIXA, pay);
		}
	}
	
	public INDRA_paymentWithoutGateway(pay): Observable<any> {
		if (MOCK_STATUS.PAYMENT_BANKTRANSFER_PICKUP) {
			return this.http.get<any>(MOCK_URL_PAYMENT_BANKTRANSFER_PICKUP);
		} else {
			return this.api.INDRA_post<any>(URL_PAYMENT_WITHOUT_GATEWAY, pay);
		}
	}
	
	public INDRA_applyCCFee(surchargePercentage): Observable<any> {
		if (MOCK_STATUS.PAYMENT_CC_FEE) {
			const urlMock = surchargePercentage > 0 ? MOCK_URL_PAYMENT_CC_FEE : MOCK_URL_PAYMENT_CC_FEE_ZERO;
			return this.http.get<any>(urlMock);
		} else {
			return this.api.INDRA_post<any>(`${URL_PAYMENT_APPLY_CC_FEE}${surchargePercentage}`, {});
		}
	}

	public INDRA_redeemVoucher(): Observable<INDRARedeemVoucherDetail> {
		if (MOCK_STATUS.REDEEM_VOUCHER) {
			return this.http.get<INDRARedeemVoucherDetail>(MOCK_URL_REDEEM_VOUCHER);
		} else {
			return this.api.INDRA_post<INDRARedeemVoucherDetail>(URL_REDEEM_VOUCHER, {});
		}
	}

	public INDRA_paybyrdCheckOut(dataPay): Observable<any> {
    	if (MOCK_STATUS.PAYBYRD_CHECKOUT) {
    		return this.http.get<any>(MOCK_PAYBYRD_CHECKOUT);
    	} else {
    		return this.api.INDRA_post<any>(URL_CHECKOUT_PAYBYRD, dataPay);
    	}
    }

	public INDRA_setTriggerHppRedFlag(value: boolean) {
		this._triggerHppRedFlag.next(value);
	}

}
